import axios from 'axios';

let activeRequests = 0;

const customerArrayBufferApi = axios.create({
  responseType: 'arraybuffer',
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});

customerArrayBufferApi.interceptors.request.use((req) => {
  if (activeRequests === 0) {
    document.body.classList.add('loading-indicator');
  }
  activeRequests += 1;

  if (typeof window !== 'undefined' && window.localStorage.getItem('accessToken')) {
    req.headers.authorization = `Bearer ${window.localStorage.getItem('accessToken')}`;
  }
  return req;
});

customerArrayBufferApi.interceptors.response.use((response) => {
  if (activeRequests > 0) {
    activeRequests -= 1;
  }
  if (activeRequests === 0) {
    // Remove loading indicator only if there are no active requests
    setTimeout(() => document.body.classList.remove('loading-indicator'), 300);
  }

  return response;
}, (error) => {
  activeRequests -= 1;

  if (activeRequests === 0) {
    // Remove loading indicator only if there are no active requests
    setTimeout(() => document.body.classList.remove('loading-indicator'), 300);
  }
  return Promise.reject(error);
});

export default customerArrayBufferApi;
